export default "__VITE_ASSET__D55kFiPv__"